// extracted by mini-css-extract-plugin
module.exports = {"PodSmallRegularLayout":"TaggedArticles_PodSmallRegularLayout__3tJgM","PodSmallRegularBox":"TaggedArticles_PodSmallRegularBox__1chlh"};